var exports = {
  "an": "ErrorFallback.module__errorFallbackContainer___bjJZNz",
  "MU": "ErrorFallback.module__errorFallbackIcon___bjJZNz",
  "S6": "ErrorFallback.module__errorFallbackContent___bjJZNz",
  "jQ": "ErrorFallback.module__errorFallbackTitle___bjJZNz",
  "pF": "ErrorFallback.module__errorFallbackDescription___bjJZNz",
  "sM": "ErrorFallback.module__errorFallbackActions___bjJZNz",
};

module.exports = exports;
